import { Department } from '../enums/department.enum';
import { Rol } from '../enums/rol.enum';

export const DEPARTMENT_LABELS = [
  { label: 'Contabilidad', value: Department.Accounting },
  { label: 'Laboral', value: Department.Labor },
  { label: 'Fiscal', value: Department.Fiscal },
  { label: 'Facturación', value: Department.Billing },
  { label: 'General', value: Department.General }
];

export const ROL_LABELS = [
  { label: 'Administrador', value: Rol.Admin },
  { label: 'Oficina', value: Rol.Office },
  { label: 'Gestor Clientes', value: Rol.ClientManager },
  { label: 'Gestor Declaraciones', value: Rol.DeclarationsManager },
  { label: 'Gestor Usuarios', value: Rol.UsersManager },
];

export const getDepartmentLabel = (department: string): string => {
  const found = DEPARTMENT_LABELS.find(d => d.value === department);
  return found ? found.label : department;
};

export const getRolLabel = (rol: string): string => {
  const found = ROL_LABELS.find(r => r.value === rol);
  return found ? found.label : rol;
};
